module.exports = __webpack_public_path__ + "img/pl.8a30117f.svg";